import { ArrowDown01Icon } from '@hugeicons/react'
import clsx from 'clsx'

import { Label } from '@/components/ui/label'

import { controlVariants } from '@/shared/ui/Form/control-styles'

import type { ResourceFilterOption } from './types'

const selectFieldClassName = clsx(
  controlVariants({ size: 'md' }),
  'appearance-none pr-9 font-medium shadow-sm'
)

type ResourceFilterSelectProps<T extends string | number> = {
  id: string
  label: string
  emptyLabel: string
  options: ResourceFilterOption<T>[]
  value: T | null | undefined
  onChange: (value: T | null) => void
}

/** Select nativo para filtros avançados no desktop. */
export const ResourceFilterSelect = <T extends string | number>({
  id,
  label,
  emptyLabel,
  options,
  value,
  onChange
}: ResourceFilterSelectProps<T>) => {
  if (options.length === 0) return null

  const valueType = typeof options[0]?.id

  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id} className="text-2xs font-bold uppercase tracking-wide text-gray-600">
        {label}
      </Label>
      <div className="relative">
        <select
          id={id}
          value={value ?? ''}
          onChange={event => {
            const nextValue = event.target.value
            if (nextValue === '') {
              onChange(null)
              return
            }

            onChange(
              (valueType === 'number' ? Number(nextValue) : nextValue) as T
            )
          }}
          className={selectFieldClassName}
        >
          <option value="">{emptyLabel}</option>
          {options.map(option => (
            <option key={String(option.id)} value={String(option.id)}>
              {option.label}
            </option>
          ))}
        </select>
        <ArrowDown01Icon
          size={16}
          aria-hidden
          className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
        />
      </div>
    </div>
  )
}

ResourceFilterSelect.displayName = 'ResourceFilterSelect'
